import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';

import { QrAccessCodeType } from '@/domains';
import { translations } from '@/locale';

import Select, { Props as SelectProps } from '@/components/Select';
import { withValidation } from '@/components/hoc/withValidation';

export interface Props extends Omit<SelectProps<QrAccessCodeType>, 'items'>, WrappedComponentProps {}

const QrAccessCodeTypeSelect: React.FC<Props> = ({ intl, ...rest }) => {
  const items = Object.values(QrAccessCodeType).map((type) => ({
    value: type,
    name: intl.formatMessage({ id: translations.domains.qrAccessCodeType[type] })
  }));

  return <Select {...rest} items={items} />;
};

const Default = injectIntl(QrAccessCodeTypeSelect);
export const QrAccessCodeTypeSelectWithValidation = withValidation(Default);
export default Default;
